import { api } from "aldoo-ra/API"

const meetAPI = api("contacts")

export async function listContacts() {
  return meetAPI({ contactsList: {} })
}

export async function addContact({ userId, name, email, avatar }) {
  return meetAPI({ contactsAdd: { userId, name, email, avatar } })
}

export async function addContactsBulk(emails) {
  return meetAPI({ contactsAddBulk: { emails } })
}

export async function removeContact(userId) {
  return meetAPI({ contactsRemove: { userId } })
}

// Recent recipients — emails the user has actually shared with. Used by the
// "Recent" tab inside ContactsPanel.
export async function listRecentRecipients() {
  return meetAPI({ recentRecipientsList: {} })
}

// ── Contact groups ──────────────────────────────────────────────────────────
export async function listGroups() {
  return meetAPI({ groupsList: {} })
}

export async function addGroup(name) {
  return meetAPI({ groupAdd: { name } })
}

export async function removeGroup(groupId) {
  return meetAPI({ groupRemove: { groupId } })
}

export async function renameGroup(groupId, name) {
  return meetAPI({ groupRename: { groupId, name } })
}

export async function addGroupMember(groupId, userId) {
  return meetAPI({ groupAddMember: { groupId, userId } })
}

export async function removeGroupMember(groupId, userId) {
  return meetAPI({ groupRemoveMember: { groupId, userId } })
}
